'use strict';

const { reject } = require('lodash');

(function (angular) {
	angular.module('PinMeTo.services').service('pmtAlertService', [
		'$i18next',
		function ($i18next) {
			this.alertBox = {
				active: false,
				confirmTitle: 'Ok',
				cancelTitle: 'Cancel'
			};

			this.alert = function (caller) {
				this.alertBox.active = true;
				this.alertBox.busy = false;
				this.alertBox.title = caller.title;
				this.alertBox.body = caller.body;
				this.alertBox.confirm = caller.confirm;
				this.alertBox.cancel = caller.cancel;
				this.alertBox.confirmTitle = caller.confirmTitle || 'Ok';
				this.alertBox.cancelTitle = caller.cancelTitle || 'Cancel';
			};

			this.close = function () {
				this.alertBox.active = false;
				this.alertBox.confirmTitle = 'Ok';
				this.alertBox.cancelTitle = 'Cancel';
				delete this.alertBox.title;
				delete this.alertBox.body;
				delete this.alertBox.confirm;
				delete this.alertBox.cancel;
				delete this.alertBox.busy;
			};

			this.errorAlert = (error, title = 'Error') => {
				const errorLookup = {
					400: $i18next.t('posts.post_service.error400'),
					401: $i18next.t('posts.post_service.error401'),
					403: $i18next.t('posts.post_service.error403'),
					500: $i18next.t('posts.post_service.error500'),
					502: $i18next.t('posts.post_service.error502504'),
					504: $i18next.t('posts.post_service.error502504')
				};

				const errorMessage = (function () {
					if (typeof error === 'string') {
						if (error.includes('TypeError')) {
							return $i18next.t('general.unknown_error');
						}
						return error;
					}
					if (error && error.message) {
						return error.message;
					}
					if (error && typeof error.data === 'string') {
						return error.data;
					}

					return errorLookup[error.status] || $i18next.t('general.unknown_error');
				})();

				return new Promise(resolve => {
					this.alert({
						title: title,
						body: errorMessage,
						confirm: () => {
							resolve(error);
							this.close();
						}
					});
				});
			};

			this.asyncAlert = (title, message, confirmTitle, cancelTitle) =>
				new Promise(resolve =>
					this.alert({
						title,
						body: message,
						confirmTitle: confirmTitle || 'Ok',
						cancelTitle: cancelTitle || 'Cancel',
						confirm: () => {
							resolve();
							this.close();
						},
						cancel: () => {
							reject();
							this.close();
						}
					})
				);
		}
	]);
})(window.angular);
